/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { intl } from '../../providers/IntlProvider';
import { addAircraftMaintenance, updateAircraft } from '../../services/api';
import { ToastCategories, ToastTypes, ToastsActionTypes } from '../toasts';
import {
  queryAircraft,
  queryAircrafts,
  queryAircraftByOperator,
  getAircraftStatus,
  querySimpleAircraftByOperator,
} from '../../services/apiNew';
import { Operator } from '../userSettings';
import { Maintenance } from '../maintenance';
import { Aircraft, AircraftActionTypes } from './index';

export function getAllAircraft() {
  return async (dispatch: Dispatch): Promise<any> => {
    const res = await queryAircrafts();
    dispatch({
      type: AircraftActionTypes.SAVE_ALL,
      payload: res.data,
    });
  };
}

export const getAircraftByOperators =
  (operator: Operator) =>
  async (dispatch: Dispatch): Promise<any> => {
    const res = await queryAircraftByOperator(operator.id);
    dispatch({
      type: AircraftActionTypes.SAVE_FLEET,
      payload: res.data,
    });
  };

export const updateAircraftInFleet =
  (aircraft: Aircraft) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch({
      type: AircraftActionTypes.SAVE_FLEET,
      payload: [aircraft],
    });
  };

export const getSimpleAircraftByOperators = (operator: Operator) => async (): Promise<any> => {
  const res = await querySimpleAircraftByOperator(operator.id);
  if (res.status >= 199 || res.status <= 400) {
    return res.data;
  }
  return null;
};

export const fetchAircraftStatus =
  ({ payload }: { payload: string }) =>
  async (dispatch: Dispatch): Promise<any> => {
    const res = await getAircraftStatus(payload);
    dispatch({
      type: AircraftActionTypes.SAVE_STATUS,
      payload: {
        maintenance_status: res.data,
        id: payload,
      },
    });
  };

export const saveAllAircraft =
  ({ payload }: { payload: Aircraft[] }) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch({
      type: AircraftActionTypes.SAVE_ALL,
      payload,
    });
  };

export const getSingleAircraft =
  ({ payload }: { payload: string }) =>
  async (dispatch: Dispatch): Promise<any> => {
    const response = await queryAircraft(payload);
    if (response.statusText === 'OK') {
      dispatch({
        type: AircraftActionTypes.SAVE,
        payload: response.data,
      });
    }
  };

export const saveSingleAircraft =
  ({ payload }: { payload: Aircraft }) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch({
      type: AircraftActionTypes.SAVE,
      payload,
    });
  };

export const fetch =
  ({ payload }: { payload: string }) =>
  async (dispatch: Dispatch): Promise<any> => {
    console.error('aircraft/fetch is deprecated please use getSingleAircraft instead');
    const response = await queryAircraft(payload);
      dispatch({
        type: AircraftActionTypes.SAVE,
        payload: response.data,
      });
  };

export const add =
  ({ payload }: { payload: Aircraft }) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch({
      type: AircraftActionTypes.SAVE_NEW,
      payload,
    });
  };

export interface addMaintenancePayload {
  id: string;
  aircraft: string;
  itemData: Maintenance;
  aircraft_id: string;
  organisation_id: string;
};

export const addMaintenance =
  ({ payload }: { payload: addMaintenancePayload }) =>
  async (dispatch: Dispatch): Promise<any> => {
    const response = await addAircraftMaintenance(payload);
    if (response.statusCode > 199 && response.statusCode < 400) {
      dispatch({
        type: AircraftActionTypes.SAVE_NEW,
        payload: response.body.aircraft,
      });
    }
  };

export const update =
  ({ payload }: { payload: { aircraftId: string; aircraft: Aircraft } }) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await updateAircraft(payload);
    if (response.statusCode > 199 && response.statusCode < 400) {
      dispatch({
        type: ToastsActionTypes.ADD_TOAST,
        payload: {
          title: intl.formatMessage({ id: 'message.aircraftUpdated' }),
          type: ToastTypes.SUCCESS,
          category: ToastCategories.FLASH,
          message: '',
        },
      });
      dispatch({
        type: AircraftActionTypes.SAVE,
        payload: response.body,
      });
    }
  };

export const updateNewAircraft =
  ({ payload }: { payload: Aircraft }) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch({
      type: AircraftActionTypes.SAVE_NEW,
      payload,
    });
  };

export const updateSkipAPI =
  ({ payload }: { payload: Aircraft }) =>
  async (dispatch: Dispatch): Promise<any> => {
    dispatch({
      type: AircraftActionTypes.SAVE,
      payload,
    });
  };
